module.exports = __webpack_public_path__ + "static/Ginecologia-9c963ac85b39cf14957b30fc85680772.jpeg";